// React Thirty Party Library
import { Typography, Badge, Row, Col, Popover, Flex, Progress, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

// Constant
import { TEMPLATE, ROOT_CONSTANT } from "../../../constants";

// Components
import { ButtonLink, Options } from "../../../components";

//handlers
import { filter } from "../../../handlers";

// Service Library
import { TIME } from "../../../services/util";

// Style
import "./index.css";

const { 
  TABLE_PAYROLL_TITLE, 
  TABLE_PAYROLL_INDEX, 
  PAYROLL_STATUS_TITLE, 
  PAYROLL_FILE_TITLE, 
  PAYROLL_FILE_INDEX,
  PAYROLL_FILE_ISCLOSED,
  PAYROLL_FILE_EXPAND_TITLE,
  PAYROLL_FILE_EXPAND_INDEX,
} = TEMPLATE.PAYROLL;
const { icon_comment } = ROOT_CONSTANT.IMG.ICON;
const { bankList } = Options;
const { parseTimeMin } = TIME;
const { searchHDLR, filterHDLR } = filter;
const { Text } = Typography;

const getBankIcon = (bankName) => {
  const matchedBank = bankList.find((bank) => bank.value.name === bankName);
  return matchedBank ? matchedBank.icon : null;
};

const formatIC = (ic) => {
  if (!ic) {
    return "";
  }
  let cleanedIC = ic.replace(/\D/g, "");

  if (cleanedIC.length > 12) {
    cleanedIC = cleanedIC.slice(0, 12);
  }

  if (cleanedIC.length < 12) {
    cleanedIC = cleanedIC.padEnd(12, "_");
  }
  return (
    cleanedIC.slice(0, 6) +
    "-" +
    cleanedIC.slice(6, 8) +
    "-" +
    cleanedIC.slice(8)
  );
};

export const PAYROLL_SUMMARY_COL = ({
  redux = {},
  func = {},
  exportState = false,
}) => {
  const { user, company = {} } = redux;
  const { handleSearch, DrawerRemark } = func;

  const columns = [
    {
      title: TABLE_PAYROLL_TITLE.PayrollID,
      key: TABLE_PAYROLL_INDEX.PayrollID,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { prid } = record;
        return exportState ? prid : <Text>{prid}</Text>;
      },
      ...searchHDLR.getColumnSearchProps("prid", handleSearch),
    },
    {
      title: TABLE_PAYROLL_TITLE.Status,
      key: TABLE_PAYROLL_INDEX.Status,
      fixed: "left",
      render: (record) => {
        const { status } = record;
        const { name, colorTag, bgColor } = PAYROLL_STATUS_TITLE[status];

        return exportState ? (
          name
        ) : (
          <div>
            <div
              style={{
                backgroundColor: bgColor,
                display: "inline-block",
                padding: "3px 13px",
                borderRadius: "30px",
              }}
            >
              <Badge
                color={colorTag}
                text={<span style={{ color: colorTag }}>{name}</span>}
              />
            </div>
            {status === 2 ? (
              user.uroleid === "EMR" ? (
                <Popover
                  content={
                    <>
                      <div>
                        The payroll advance request is currently on hold. Please
                        contact Bolt advance admin to increase the limit.
                      </div>
                    </>
                  }
                >
                  <InfoCircleOutlined
                    style={{
                      color: "#FF0000",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </Popover>
              ) : (
                <Popover
                  content={
                    <>
                      <div>
                        The payroll request is on hold due to exceeding the
                        company's limit.
                      </div>
                    </>
                  }
                >
                  <InfoCircleOutlined
                    style={{
                      color: "#FF0000",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                  />
                </Popover>
              )
            ) : null}
          </div>
        );
      },
      filters: filterHDLR.getColumnsFilterStatus(PAYROLL_STATUS_TITLE),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: TABLE_PAYROLL_TITLE.Name,
      key: TABLE_PAYROLL_INDEX.Name,
      width: 200,
      render: (record) => {
        const { emp_name, emp_contact } = record;

        const emp = `${emp_name || ""}${emp_name && emp_contact ? " /" : ""}${
          emp_contact || ""
        }`;

        return exportState ? emp_name : <Text>{emp}</Text>;
      },
      ...searchHDLR.getColumnSearchProps("emp_name", handleSearch),
      sorter: true,
    },

    ...(exportState
      ? [
          {
            title: TABLE_PAYROLL_TITLE.Contact,
            width: 200,
            render: (record) => {
              const { emp_contact } = record;

              return exportState && emp_contact;
            },
          },
          {
            title: TABLE_PAYROLL_TITLE.IC,
            width: 200,
            render: (record) => {
              const { emp_ic } = record;

              return exportState ? emp_ic : <Text>{emp_ic}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("emp_ic", handleSearch),
          }, 
          {
            title: TABLE_PAYROLL_TITLE.Reference,
            width: 200,
            render: (record) => {
              const { emp_refid } = record;

              return exportState ? (
                emp_refid
              ) : (
                <Text>{emp_refid}</Text>
              );
            },
            ...searchHDLR.getColumnSearchProps("emp_refid", handleSearch),
          },
        ]
      : []),
    ...(user.uroleid === "A"
      ? [
          {
            title: TABLE_PAYROLL_TITLE.CompanyName,
            key: TABLE_PAYROLL_INDEX.CompanyName,
            width: 200,
            render: (record) => {
              const { company_name, coid } = record;

              const comp = `${company_name || ""}${company_name && coid ? " /" : ""}${coid || ""}`;
              
              return exportState ? company_name : <Text>{comp}</Text>;
            },
            filters: filterHDLR.getColumnsFilterType(company),
            onFilter: (value, record) => value.includes(record.coid),
            filterSearch: true,
          },

          ...(exportState
            ? [
                {
                  title: TABLE_PAYROLL_TITLE.CompanyId,
                  width: 200,
                  render: (record) => {
                    const { coid } = record;

                    return exportState ? coid : <Text>{coid}</Text>;
                  },
                },
              ]
            : []),
        ]
      : []),

    {
      title: TABLE_PAYROLL_TITLE.RequestAmount,
      key: TABLE_PAYROLL_INDEX.RequestAmount,
      width: 200,
      render: (record) => {
        const { reqAmount } = record;
        return exportState ? reqAmount : <Text> RM {reqAmount} </Text>;
      },
      sorter: true,
    },
    {
      title: TABLE_PAYROLL_TITLE.DisburseAmount,
      key: TABLE_PAYROLL_INDEX.DisburseAmount,
      width: 200,
      render: (record) => {
        const { nda } = record;
        return exportState ? nda : <Text> RM {nda} </Text>;
      },
      sorter: true,
    },
    {
      title: TABLE_PAYROLL_TITLE.AdminFees,
      // key: TABLE_PAYROLL_INDEX.,
      width: 200,
      render: (record) => {
        const { netFee, fee, discount } = record;

        const discInt = parseInt(discount);
        const deduction = discInt / 100 * fee;

        return exportState ? ( 
          netFee
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>RM {netFee}</div>
            <Popover
                content={
                  <>
                    <div>RM{fee}-RM{deduction} ({discount})</div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#878787",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                />
              </Popover>
          </div>
          
        );
      },
      sorter: true,
    },
    // ...(user.uroleid === 'A' ? [
    {
      title: TABLE_PAYROLL_TITLE.ApplicationReason,
      width: 200,
      render: (record) => {
        const { reason } = record;

        const type =
          reason &&
          typeof reason === "object" &&
          Object.prototype.hasOwnProperty.call(reason, "type")
            ? reason.type
            : "";

        return exportState ? (
          type
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>{type}</div>
            {type === "Other" ? (
              <Popover
                content={
                  <>
                    <div>{reason.desc ? reason.desc : "-"}</div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#878787",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                />
              </Popover>
            ) : null}
          </div>
        );
      },
    },
    {
      title: TABLE_PAYROLL_TITLE.Loyalty,
      // key: TABLE_PAYROLL_INDEX.,
      width: 200,
      render: (record) => {
        const { loyalty, loyaltyTier } = record;

        const loyaltyID =
          loyaltyTier && loyaltyTier.includes("LT") && loyaltyTier;

        // Add a check to ensure loyalty and loyalty.tiers are defined
        const tiers = loyalty && loyalty.tiers ? loyalty.tiers : {};
        const ltyid = loyalty ? loyalty.ltyid : "";

        const { name = "", discount = {} } = tiers[loyaltyID] || {};
        const tierExp = ltyid
          ? `${ltyid || ""}-${name || ""} (${discount?.amount || ""}${
              discount?.type || ""
            })`
          : "-";

        const tier = name ? (
          <>
            <span>{loyalty.name}</span>
            <br />
            <span>
              {ltyid}-{name} ({discount?.amount || ""}
              {discount?.type || ""})
            </span>
          </>
        ) : (
          ""
        );

        return exportState ? tierExp : <>{tier}</>;
        // return exportState ? loyaltyTier : <>{loyaltyTier}</>;
      },
      // sorter: (a, b) => a.loyaltyTier - b.loyaltyTier,
    },

    ...(!exportState
      ? [
          {
            title: TABLE_PAYROLL_TITLE.BankInformation,
            width: 220,
            render: (record) => {
              const { employee_ic, bank } = record;

              const { name, acc, holder } = bank;

              const formattedEmployeeIC = formatIC(employee_ic);
              const formattedBankHolderIc = formatIC(holder?.ic);

              const isBankHolderICMatchIC =
                formattedEmployeeIC === formattedBankHolderIc;

              // const bankInfo = name && acc ? `${name} /${acc}` : "";

              return (
                <>
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "180px",
                      textAlign: "left",
                    }}
                  >
                    <Col style={{ width: "30px" }}>{getBankIcon(name)}</Col>
                    <Col>{name}</Col>
                  </Row>
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "180px",
                      textAlign: "left",
                    }}
                  >
                    <Col style={{ width: "30px" }}>
                      {isBankHolderICMatchIC ? null : (
                        <Popover
                          content={
                            <>
                              <div>Bank holder name: {holder?.name}</div>
                              <div>Bank holder IC: {formattedBankHolderIc}</div>
                            </>
                          }
                        >
                          <InfoCircleOutlined
                            style={{
                              color: "rgba(0,0,0,.45)",
                              marginRight: "10px",
                              cursor: "pointer",
                            }}
                          />
                        </Popover>
                      )}
                    </Col>
                    <Col>
                      {acc}
                      <br />
                    </Col>
                  </Row>
                </>
              );
            },
            ...searchHDLR.getColumnSearchProps("bankName", handleSearch),
          },
        ]
      : []),
    ...(exportState
      ? [
          {
            title: TABLE_PAYROLL_TITLE.BankName,
            width: 200,
            render: (record) => {
              const { bank } = record;

              const { name } = bank;

              return exportState ? name : <Text>{name}</Text>;
            },
          },
          {
            title: TABLE_PAYROLL_TITLE.BankAcc,
            width: 200,
            render: (record) => {
              const { bank } = record;

              const { acc } = bank;

              return exportState ? acc : <Text>{acc}</Text>;
            },
          },
          {
            title: TABLE_PAYROLL_TITLE.BankHolderName,
            width: 200,
            render: (record) => {
              const { bank } = record;

              const { holder } = bank;

              const holderName = holder ? holder.name : "";

              return exportState ? holderName : <Text>{holderName}</Text>;
            },
          },
          {
            title: TABLE_PAYROLL_TITLE.BankHolderIC,
            width: 200,
            render: (record) => {
              const { bank } = record;

              const { holder } = bank;

              const holderIC = holder ? holder.ic : "";

              return exportState ? holderIC : <Text>{holderIC}</Text>;
            },
          },
        ]
      : []),
    ...(user.uroleid === "A"
      ? [
          {
            title: TABLE_PAYROLL_TITLE.BankPaymentFile,
            key: TABLE_PAYROLL_INDEX.BankPaymentFile,
            render: (record) => {
              const { attachment = {}, rhbName } = record;
              const rhb = attachment?.rhb?.csv;

              if (exportState) {
                return rhbName ? rhbName : "";
              } else {
                return rhbName ? (
                  <ButtonLink onClick={() => window.open(rhb, "_blank")}>
                    {rhbName}
                  </ButtonLink>
                ) : null;
              }
            },
            ...searchHDLR.getColumnSearchProps("rhbName", handleSearch),
          },
        ]
      : []),
    {
      title: TABLE_PAYROLL_TITLE.BillingID,
      // key: TABLE_PAYROLL_INDEX.,
      width: 200,
      render: (record) => {
        const { billid } = record;

        const billidCheck = billid === undefined ? " " : billid;

        return exportState ? billidCheck : <Text> {billidCheck} </Text>;
      },
      ...searchHDLR.getColumnSearchProps("billid", handleSearch),
    },
    {
      title: TABLE_PAYROLL_TITLE.UpdatedAt,
      key: TABLE_PAYROLL_INDEX.UpdatedAt,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = updatedBy_name ? `${updatedBy_name} /${updatedBy}` : `${updatedBy}`
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_PAYROLL_TITLE.CreatedAt,
      key: TABLE_PAYROLL_INDEX.CreatedAt,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = `${createdBy_name} /${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_PAYROLL_TITLE.Remarks,
      width: 180,
      fixed: "right",
      render: (record) => {
        const { remarkCount } = record;
        return (
          <Badge
            count={remarkCount || 0}
            showZero
            offset={[10, 10]}
            color="#0E2483"
          >
            <ButtonLink
              onClick={() => {
                DrawerRemark(record);
              }}
            >
              <img src={icon_comment} alt="" />
            </ButtonLink>
          </Badge>
        );
      },
    },
  ];

  return columns;
};

export const BULK_UPLOAD_REVIEW_COLUMN = () => {
  const { TABLE_BULK_UPLOAD_INDEX, TABLE_PAYROLL_TITLE_BULK } =
    TEMPLATE.EMPLOYEE;

  return TABLE_BULK_UPLOAD_INDEX.map((index) => ({
    title: TABLE_PAYROLL_TITLE_BULK[index],
    key: index,
    dataIndex: index,
    editable: true,
  }));
};

export const PAYROLL_FILE_COL = ({
  redux = {},
  func = {},
  exportState = false,
}) => {
  const { user, company = {}, payroll } = redux;
  const { handleSearch, DrawerRemark } = func;

  const columns = [
    {
      title: PAYROLL_FILE_TITLE.PaymentFile,
      key: PAYROLL_FILE_INDEX.PaymentFile,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { attachment, rhbName } = record;
        
        return exportState ? attachment : 
        <a href={attachment?.rhb?.csv} download={attachment?.rhb?.csv} target="_blank" rel="noopener noreferrer">
            {rhbName || ""}
        </a>;
      },
      ...searchHDLR.getColumnSearchProps("rhbName", handleSearch),
    },
    {
      title: PAYROLL_FILE_TITLE.Status,
      key: PAYROLL_FILE_INDEX.Status,
      width: 180,
      render: (record) => {
        const { isClosed } = record;
        const { name, colorTag, bgColor } = PAYROLL_FILE_ISCLOSED[isClosed];

        return exportState ? 
        (
          <Text>{PAYROLL_FILE_ISCLOSED[isClosed]?.name}</Text>
        ) : (
          <div
              style={{
                backgroundColor: bgColor,
                display: "inline-block",
                padding: "3px 13px",
                borderRadius: "30px",
              }}
            >
              <Badge
                color={colorTag}
                text={<span style={{ color: colorTag }}>{name}</span>}
              />
            </div>
        );
      },  
    },
    {
      title: PAYROLL_FILE_TITLE.TotalPayroll,
      key: PAYROLL_FILE_INDEX.TotalPayroll,
      width: 180,
      render: (record) => {
        const { totalPayroll } = record;
        return exportState ? (
          <Text>{totalPayroll}</Text>
        ) : (
          <Text>{totalPayroll}</Text>
        );
      },
    },
    {
      title: PAYROLL_FILE_TITLE.TotalPaymentFile,
      key: PAYROLL_FILE_INDEX.TotalPaymentFile,
      width: 180,
      render: (record) => {
        const { totalPaymentAmount } = record;
        return exportState ? (
          <Text>RM {totalPaymentAmount}</Text>
        ) : (
          <Text>RM {totalPaymentAmount}</Text>
        );
      },
      sorter: true,
    },
    {
      title: PAYROLL_FILE_TITLE.PayrollAdvanceSummary,
      key: PAYROLL_FILE_INDEX.PayrollAdvanceSummary,
      width: 560,
      render: (record) => {
        const { payroll, totalPayroll, advanceSummary } = record;
        const bankProcessing = advanceSummary?.[3] ? advanceSummary[3] : 0;
        const disbursed = advanceSummary?.[4] ? advanceSummary[4] : 0;
        const cancelled = advanceSummary?.[0] ? advanceSummary[0] : 0;

        const getPercentage = (value) => (value / totalPayroll) * 100 + '%';

        return exportState ? (
          <Text>{payroll}</Text>
        ) : (
          <>
            <div className="status-bar-container">
              <Row gutter={[16, 16]} align="middle">
                <Col span={24}>
                  <div className="progress-bar">
                    <div 
                      className="progress-section blue-section" 
                      style={{ width: getPercentage(bankProcessing) }}
                    ></div>
                    <div 
                      className="progress-section green-section" 
                      style={{ width: getPercentage(disbursed) }}
                    ></div>
                    <div 
                      className="progress-section red-section" 
                      style={{ width: getPercentage(cancelled) }}
                    ></div>
                  </div>
                </Col>
                <Col span={8}>
                  <Text className="blue-text">
                    Bank Processing: {bankProcessing}
                  </Text>
                  <Text className="green-text">
                    Disbursed: {disbursed}
                  </Text>
                  <Text className="red-text">
                    Cancelled: {cancelled}
                  </Text>
                </Col>
              </Row>
            </div>
          </>
        );
      },
    },
    {
      title: PAYROLL_FILE_TITLE.AssociatedCompany,
      key: PAYROLL_FILE_INDEX.AssociatedCompany,
      width: 180,
      render: (record) => {
        const { companyCountMap } = record;
        const formattedString = companyCountMap
          .map(item => `${item.company_type}(${item.count})`)
          .join(', ');

        return exportState ? (
          <Text>{formattedString}</Text>
        ) : (
          <Text>{formattedString}</Text>
        );
      },
      sorter: true,
    },
    {
      title: PAYROLL_FILE_TITLE.GeneratedBy,
      key: PAYROLL_FILE_INDEX.GeneratedBy,
      width: 180,
      render: (record) => {
        const { payrolls, generatedBy } = record;

        return exportState ? (
          <Text></Text>
        ) : (
          <Text>
            {generatedBy}
            <br />
            {parseTimeMin(payrolls[0]?.createdAt)}
          </Text>
        );
      },
      sorter: true,
    },
    {
      title: PAYROLL_FILE_TITLE.Remarks,
      key: PAYROLL_FILE_INDEX.Remarks,
      width: 180,
      fixed: "right",
      render: (record) => {
        const { remark, remarkCount } = record;
        return (
          <Badge
            count={remarkCount || 0}
            showZero
            offset={[10, 10]}
            color="#0E2483"
          >
            <ButtonLink
              onClick={() => {
                DrawerRemark(record);
              }}
            >
              <img src={icon_comment} alt="" />
            </ButtonLink>
          </Badge>
        )
      },
    },
  ];

  return columns;
};

export const EXPAND_PAYROLL_FILE_COL = ({
  redux = {},
  func = {},
  exportState = false,
}) => {
  const { user, company = {}, payroll } = redux;
  const { handleSearch, DrawerRemark } = func;

  const columns = [
    {
      title: PAYROLL_FILE_EXPAND_TITLE.PayrollID,
      key: PAYROLL_FILE_EXPAND_INDEX.PayrollID,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { prid } = record;
        return exportState ? prid : <Text>{prid}</Text>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.Status,
      key: "status",
      width: 180,
      render: (record) => {
        const { status } = record;
        const { name, colorTag, bgColor } = PAYROLL_STATUS_TITLE[status];

        return exportState ? (
          name
        ) : (
          <div>
            <div
              style={{
                backgroundColor: bgColor,
                display: "inline-block",
                padding: "3px 13px",
                borderRadius: "30px",
              }}
            >
              <Badge
                color={colorTag}
                text={<span style={{ color: colorTag }}>{name}</span>}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.Name,
      key: PAYROLL_FILE_EXPAND_INDEX.Name,
      width: 200,
      render: (record) => {
        const { emp_name, emp_contact } = record;

        const emp = `${emp_name || ""}${emp_name && emp_contact ? " /" : ""}${
          emp_contact || ""
        }`;

        return exportState ? emp_name : <Text>{emp}</Text>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.CompanyName,
      key: PAYROLL_FILE_EXPAND_INDEX.CompanyName,
      width: 300,
      render: (record) => {
        const { company_name, coid } = record;

        const comp = `${company_name || ""}${
          company_name && coid ? " /" : ""
        }${coid || ""}`;
        return exportState ? company_name : <Text>{comp}</Text>;
      },
    },
    { 
      title: PAYROLL_FILE_EXPAND_TITLE.RequestAmount,
      key: "request_amount",
      width: 180,
      render: (record) => {
        const { reqAmount } = record;
        return exportState ? reqAmount : <Text> RM {reqAmount} </Text>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.DisburseAmount,
      key: "disburse_amount",
      width: 180,
      render: (record) => {
        const { nda } = record;
        return exportState ? nda : <Text> RM {nda} </Text>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.AdminFees, 
      key: "admin_fees",
      width: 180,
      render: (record) => {
        const { netFee } = record;

        return exportState ? netFee : <Text> RM {netFee} </Text>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.Loyalty,
      key: "loyalty",
      width: 180,
      render: (record) => {
        const { loyalty, loyaltyTier } = record;

        const loyaltyID = loyaltyTier && loyaltyTier.includes("LT") && loyaltyTier;

        const tiers = loyalty && loyalty.tiers ? loyalty.tiers : {};
        const ltyid = loyalty ? loyalty.ltyid : "";

        const { name = "", discount = {} } = tiers[loyaltyID] || {};
        const tierExp = ltyid
          ? `${ltyid || ""}-${name || ""} (${discount?.amount || ""}${
              discount?.type || ""
            })`
          : "-";

        const tier = name ? (
          <>
            <span>{loyalty.name}</span>
            <br />
            <span>
              {ltyid}-{name} ({discount?.amount || ""}
              {discount?.type || ""})
            </span>
          </>
        ) : (
          ""
        );

        return exportState ? tierExp : <>{tier}</>;
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.BankInformation,
      key: "bank_information",
      width: 180,
      render: (record) => {
        const { employee_ic, bank } = record;

        const { name, acc, holder } = bank;

        const formattedEmployeeIC = formatIC(employee_ic);
        const formattedBankHolderIc = formatIC(holder?.ic);

        const isBankHolderICMatchIC =
          formattedEmployeeIC === formattedBankHolderIc;

        // const bankInfo = name && acc ? `${name} /${acc}` : "";

        return (
          <>
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                width: "180px",
                textAlign: "left",
              }}
            >
              <Col style={{ width: "30px" }}>{getBankIcon(name)}</Col>
              <Col>{name}</Col>
            </Row>
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                width: "180px",
                textAlign: "left",
              }}
            >
              <Col style={{ width: "30px" }}>
                {isBankHolderICMatchIC ? null : (
                  <Popover
                    content={
                      <>
                        <div>Bank holder name: {holder?.name}</div>
                        <div>Bank holder IC: {formattedBankHolderIc}</div>
                      </>
                    }
                  >
                    <InfoCircleOutlined
                      style={{
                        color: "rgba(0,0,0,.45)",
                        marginRight: "10px",
                        cursor: "pointer",
                      }}
                    />
                  </Popover>
                )}
              </Col>
              <Col>
                {acc}
                <br />
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.CreatedAt,
      key: "created_at",
      width: 180,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = `${createdBy_name} /${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}
          </span>
        );
      },
    },
    {
      title: PAYROLL_FILE_EXPAND_TITLE.UpdatedAt,
      key: "updated_at",
      width: 180,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = updatedBy_name ? `${updatedBy_name} /${updatedBy}` : `${updatedBy}`
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },      
    },
  ];

  return columns;
};
